import { Fragment } from "react"
import Header from "./Header"
import SearchFoodOverlay from "components/search/SearchFoodOverlay"
import { SearchFoodResultType } from "model/food/types"

interface ISearchFoodSectionProps {
  onBack: () => void
  onSelectFood: (food: SearchFoodResultType) => void
}

const SearchFoodSection = (props: ISearchFoodSectionProps) => {
  const { onBack, onSelectFood } = props
  return (
    <Fragment>
      <Header onBack={onBack} />
      <SearchFoodOverlay
        visible={true}
        onClose={() => {}}
        onAdd={() => {}}
        onSelect={onSelectFood}
        hideAddBtn
      />
    </Fragment>
  )
}

export default SearchFoodSection
